import {Component} from '@angular/core';
import {kanAuthService} from "../../../services/services/auth";

@Component({
    selector: 'kan-main',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanMain {

    constructor(private authService: kanAuthService) {

    }

    get role(): string {
        return this.authService.role;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/main/component.ts